export const handleRedirectSession = (redirectLink, hasMrId, testSessionMrId) => {
  let redirectLinkUrl = redirectLink;
  const newUrlRedirectLink = new URL(redirectLink);
  if (hasMrId && testSessionMrId) {
    if (newUrlRedirectLink.searchParams.size >= 1) {
      redirectLinkUrl = `${redirectLink}&tk=${testSessionMrId}`;
    } else {
      redirectLinkUrl = `${redirectLink}?tk=${testSessionMrId}`;
    }
  }
  window.open(redirectLinkUrl, '_self');
};
